export const bog_minutes_pdf=[
    {
        'id':"5",
        "head":"30th BoG minutes",
        "house":"right",
        "pdf":"https://drive.google.com/file/d/1VAFN_lQZyzHJxMw29b8VH8QsV6RwAsWS/view?usp=sharing"
    },
    {
        'id':"4",
        "head":"29th BoG minutes",
        "house":"left",
        "pdf":"https://drive.google.com/file/d/1jNIVO8gvdbOpj8TErqAYvKNijFlZuZy9/view?usp=sharing"
    },
    {
        'id':"3",
        "head":"28th BoG minutes",
        "house":"right",
        "pdf":"https://drive.google.com/file/d/1jtivM_w8XowkzpYCSw7-CsNGuwxuCIEC/view?usp=sharing"
    },
    {
        'id':"2",
        "head":"27th BoG minutes",
        "house":"left",
        "pdf":"https://drive.google.com/file/d/16k0D2REbqWUuTrBqtvelMHjigjDsCCzG/view?usp=sharing"
    },
    {
        'id':"1",
        "head":"26th BoG minutes",
        "house":"right",
        "pdf":"https://drive.google.com/file/d/1j1dMS8z4u1TJj0grE7tKSfCx21ZQ90CF/view?usp=sharing"
    },
]